// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-wait-container {
  position: absolute;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  min-width: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
}

.spinner-wait {
  position: absolute;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  top: 10%;
  bottom: auto;
  left: 40%;
  right: auto;
  min-width: 40vh;
  min-height: 40vh;
}

.inner-sidenav-content {
  position: absolute;
  overflow-y: visible !important;
  top: 70px;
  bottom: 0;
  left: 260px;
  right: 0px;
  padding-right: 20px;
  min-height: calc(100% - 70px);
}

@media only screen and (max-width: 991px) {
  .inner-sidenav-content {
    left: 5px !important;
    position: absolute;
    overflow-y: visible !important;
    top: 65px;
    bottom: 0;
    right: 0px;
    padding-right: 20px;
    min-height: calc(100% - 70px);
  }
}
.inner-sidenav-content-noleft {
  position: absolute;
  overflow-y: visible !important;
  top: 71px;
  bottom: 0;
  left: 10px;
  right: 0;
  padding-right: 10px;
  min-height: calc(100% - 70px);
}

.hide-scrool {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,cAAA;AACF;;AACA;EACE,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,8BAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;AAEF;;AACA;EACE;IACE,oBAAA;IACA,kBAAA;IACA,8BAAA;IACA,SAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,6BAAA;EAEF;AACF;AACA;EACE,kBAAA;EACA,8BAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EAEA,6BAAA;AAAF;;AAGA;EACE,2BAAA;AAAF","sourcesContent":[".spinner-wait-container {\n  position: absolute;\n  overflow-y: hidden !important;\n  overflow-x: hidden !important;\n  top: 0%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n  min-width: 100%;\n  min-height: 100vh;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 10000;\n}\n.spinner-wait {\n  position: absolute;\n  overflow-y: hidden !important;\n  overflow-x: hidden !important;\n  top: 10%;\n  bottom: auto;\n  left: 40%;\n  right: auto;\n  min-width: 40vh;\n  min-height: 40vh;\n}\n\n.inner-sidenav-content {\n  position: absolute;\n  overflow-y: visible !important;\n  top: 70px;\n  bottom: 0;\n  left: 260px;\n  right: 0px;\n  padding-right: 20px;\n  min-height: calc(100% - 70px);\n}\n\n@media only screen and (max-width: 991px) {\n  .inner-sidenav-content {\n    left: 5px !important;\n    position: absolute;\n    overflow-y: visible !important;\n    top: 65px;\n    bottom: 0;\n    right: 0px;\n    padding-right: 20px;\n    min-height: calc(100% - 70px);\n  }\n}\n\n.inner-sidenav-content-noleft {\n  position: absolute;\n  overflow-y: visible !important;\n  top: 71px;\n  bottom: 0;\n  left: 10px;\n  right: 0;\n  padding-right: 10px;\n  //padding: $inner-sidenav-content-padding;\n  min-height: calc(100% - 70px);\n}\n\n.hide-scrool {\n  overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
